export const SOLO_ANNOTATE_FILES_INVALIDATE = "SOLO_ANNOTATE_FILES_INVALIDATE";
export const SOLO_ANNOTATE_FILES_REQUEST = "SOLO_ANNOTATE_FILES_REQUEST";
export const SOLO_ANNOTATE_FILES_SUCCESS = "SOLO_ANNOTATE_FILES_SUCCESS";
export const SOLO_ANNOTATE_FILES_ERROR = "SOLO_ANNOTATE_FILES_ERROR";
export const SOLO_ANNOTATE_FILES_FETCH_REQUEST =
  "SOLO_ANNOTATE_FILES_FETCH_REQUEST";
export const SOLO_ANNOTATE_FILES_FETCH_SUCCESS =
  "SOLO_ANNOTATE_FILES_FETCH_SUCCESS";
export const SOLO_ANNOTATE_FILES_FETCH_ERROR =
  "SOLO_ANNOTATE_FILES_FETCH_ERROR";
export const SOLO_ANNOTATE_UPDATE_FILE = "SOLO_ANNOTATE_UPDATE_FILE";
export const SOLO_REMOVE_FILE_REQUEST = "SOLO_REMOVE_FILE_REQUEST";
export const SOLO_REMOVE_FILE_SUCCESS = "SOLO_REMOVE_FILE_SUCCESS";
export const SOLO_REMOVE_FILE_ERROR = "SOLO_REMOVE_FILE_ERROR";
export const SOLO_ANNOTATE_CASTS_FETCH_REQUEST =
  "SOLO_ANNOTATE_CASTS_FETCH_REQUEST";
export const SOLO_ANNOTATE_CASTS_FETCH_SUCCESS =
  "SOLO_ANNOTATE_CASTS_FETCH_SUCCESS";
export const SOLO_ANNOTATE_CASTS_FETCH_ERROR =
  "SOLO_ANNOTATE_CASTS_FETCH_ERROR";
export const SOLO_ANNOTATE_CASTS_SET_MATCHED_FORM =
  "SOLO_ANNOTATE_CASTS_SET_MATCHED_FORM";
export const SOLO_ANNOTATE_CASTS_UPDATE_MATCHED_FORM =
  "SOLO_ANNOTATE_CASTS_UPDATE_MATCHED_FORM";
export const SOLO_ANNOTATE_CASTS_UPDATE_CAST =
  "SOLO_ANNOTATE_CASTS_UPDATE_CAST";
export const SOLO_ANNOTATE_MODAL_OPEN = "SOLO_ANNOTATE_MODAL_OPEN";
export const SOLO_ANNOTATE_MODAL_CLOSE = "SOLO_ANNOTATE_MODAL_CLOSE";
export const SOLO_ANNOTATE_MODAL_SET_CAST = "SOLO_ANNOTATE_MODAL_SET_CAST";
export const SOLO_ANNOTATE_MODAL_SET_FORMS = "SOLO_ANNOTATE_MODAL_SET_FORMS";
export const SOLO_ANNOTATE_MODAL_SET_SELECTED =
  "SOLO_ANNOTATE_MODAL_SET_SELECTED";
export const SOLO_CHART_MODAL_OPEN = "SOLO_CHART_MODAL_OPEN";
export const SOLO_CHART_MODAL_CLOSE = "SOLO_CHART_MODAL_CLOSE";
export const SOLO_CHART_MODAL_SET_CAST = "SOLO_CHART_MODAL_SET_CAST";
export const SOLO_CHART_MODAL_UPDATE_CAST = "SOLO_CHART_MODAL_UPDATE_CAST";
export const SOLO_ANNOTATE_ADD_FILE_TO_ANNOTATE =
  "SOLO_ANNOTATE_ADD_FILE_TO_ANNOTATE";
export const SOLO_ANNOTATE_REMOVE_FILE_TO_ANNOTATE =
  "SOLO_ANNOTATE_REMOVE_FILE_TO_ANNOTATE";
export const SOLO_CHART_DATA_FETCH_REQUEST = "SOLO_CHART_DATA_FETCH_REQUEST";
export const SOLO_CHART_DATA_FETCH_SUCCESS = "SOLO_CHART_DATA_FETCH_SUCCESS";
export const SOLO_CHART_DATA_FETCH_ERROR = "SOLO_CHART_DATA_FETCH_ERROR";
export const SOLO_ANNOTATE_SNACKBAR_OPEN = "SOLO_ANNOTATE_SNACKBAR_OPEN";
export const SOLO_ANNOTATE_SNACKBAR_CLOSE = "SOLO_ANNOTATE_SNACKBAR_CLOSE";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
export { WORKAREA_SET } from "features/workarea/constants";
export { ORGANIZATION_SET } from "features/organization/constants";
